<template>
	<div class='text'>
		New {{ contactType }} added to the <MarketComponent :notification='notification' /> Real Estate Rolodex by <UserComponent :notification='notification' />
	</div>
</template>

<script>
import UserComponent from '../UserComponent/UserComponent.vue';
import MarketComponent from '../MarketComponent/MarketComponent.vue';

export default {
	name:       'AdditionsToRolodexText',
	components: {
		UserComponent,
		MarketComponent
	},
	props: {
		notification: {
			type: Object
		},
		contactTypes: {
			type: Object
		}
	},
	computed: {
		contactType() {
			const type = this.notification.context.contact_type.replace(' ', '_');
			return this.contactTypes[type] || 'contact';
		}
	}
};
</script>
